class ProductZoomModal extends HTMLElement {
  constructor() {
    super();
    this.currentImageIndex = 0;
    this.lastOpenButton = null;
    this.zoomScale = 1.5;
    this.isZoomed = false;
    this.activeZoomItem = null;
    this.activeZoomImage = null;
    this.panX = 0;
    this.panY = 0;
    this.dragStartX = 0;
    this.dragStartY = 0;
    this.dragStartPanX = 0;
    this.dragStartPanY = 0;
    this.activePointerId = null;
    this.isDragging = false;
    this.didDrag = false;
    this.swipePointerId = null;
    this.swipeStartX = 0;
    this.swipeStartY = 0;
    this.swipeCurrentX = 0;
    this.swipeCurrentY = 0;
    this.didSwipe = false;
    this.mobileGalleryObserver = null;

    this.desktopMediaQuery = window.matchMedia('(min-width: 900px)');

    this.handleMobileGalleryChange = this.handleMobileGalleryChange.bind(this);
    this.handleMobileGalleryClick = this.handleMobileGalleryClick.bind(this);
    this.handleOpenButtonClick = this.handleOpenButtonClick.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.handleDialogClick = this.handleDialogClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handlePreviousButtonClick = this.handlePreviousButtonClick.bind(this);
    this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
    this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    this.handleZoomButtonClick = this.handleZoomButtonClick.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.handleImagePointerDown = this.handleImagePointerDown.bind(this);
    this.handleImagePointerMove = this.handleImagePointerMove.bind(this);
    this.handleImagePointerUp = this.handleImagePointerUp.bind(this);
    this.handleViewportPointerDown = this.handleViewportPointerDown.bind(this);
    this.handleViewportPointerMove = this.handleViewportPointerMove.bind(this);
    this.handleViewportPointerUp = this.handleViewportPointerUp.bind(this);
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.scrollFrameRequested = false;
    this.handleViewportScroll = this.handleViewportScroll.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this);
    this.handleImageError = this.handleImageError.bind(this);
  }

  connectedCallback() {
    this.dialog = this.querySelector('[data-product-zoom-dialog]');
    this.viewport = this.querySelector('[data-product-zoom-viewport]');
    this.closeButton = this.querySelector('[data-product-zoom-close]');
    this.zoomButton = this.querySelector('[data-product-zoom-toggle]');
    this.zoomPlusIcon = this.querySelector('[data-product-zoom-plus-icon]');
    this.zoomMinusIcon = this.querySelector('[data-product-zoom-minus-icon]');
    this.previousButton = this.querySelector('[data-product-zoom-previous]');
    this.nextButton = this.querySelector('[data-product-zoom-next]');
    this.counter = this.querySelector('[data-product-zoom-counter]');

    this.imageItems = Array.from(this.querySelectorAll('[data-product-zoom-item]'));
    this.imageElements = Array.from(this.querySelectorAll('.product-zoom-modal__image'));
    this.thumbnailButtons = Array.from(this.querySelectorAll('[data-product-zoom-thumbnail]'));
    this.openButtons = Array.from(document.querySelectorAll('[data-product-zoom-open="' + this.id + '"]'));

    this.mobileOpenButton = document.querySelector('[data-product-zoom-mobile-trigger][data-product-zoom-open="' + this.id + '"]');
    this.mobileGalleryWrapper = this.mobileOpenButton ? this.mobileOpenButton.closest('.images_gallary_mobile') : null;
    this.mobileGallery = this.mobileGalleryWrapper ? this.mobileGalleryWrapper.querySelector('[data-product-zoom-mobile-gallery]') : null;

    this.addEventListeners();
    this.observeMobileGallery();
    this.setActiveImage(0, false);
    this.updateZoomButton();
  }
  disconnectedCallback() {
    this.removeEventListeners();
    if (this.mobileGalleryObserver !== null) {
      this.mobileGalleryObserver.disconnect();
    }
  }

  // Add event listeners
  addEventListeners() {
    for (let index = 0; index < this.openButtons.length; index += 1) {
      this.openButtons[index].addEventListener('click', this.handleOpenButtonClick);
    }

    for (let index = 0; index < this.thumbnailButtons.length; index += 1) {
      this.thumbnailButtons[index].addEventListener('click', this.handleThumbnailClick);
    }

    for (let index = 0; index < this.imageElements.length; index += 1) {
      const image = this.imageElements[index];
      image.addEventListener('click', this.handleImageClick);
      image.addEventListener('pointerdown', this.handleImagePointerDown);
      image.addEventListener('pointermove', this.handleImagePointerMove);
      image.addEventListener('pointerup', this.handleImagePointerUp);
      image.addEventListener('pointercancel', this.handleImagePointerUp);
      image.addEventListener('load', this.handleImageLoad);
      image.addEventListener('error', this.handleImageError);

      if (image.complete) {
        if (image.naturalWidth > 0) {
          this.setImageLoaded(image);
        } else {
          this.setImageError(image);
        }
      }
    }

    this.closeButton.addEventListener('click', this.handleCloseButtonClick);
    this.zoomButton.addEventListener('click', this.handleZoomButtonClick);
    this.previousButton.addEventListener('click', this.handlePreviousButtonClick);
    this.nextButton.addEventListener('click', this.handleNextButtonClick);
    this.dialog.addEventListener('click', this.handleDialogClick);
    this.dialog.addEventListener('close', this.handleDialogClose);
    this.desktopMediaQuery.addEventListener('change', this.handleBreakpointChange);
    window.addEventListener('resize', this.handleWindowResize);
    this.viewport.addEventListener('scroll', this.handleViewportScroll);
    this.viewport.addEventListener('pointerdown', this.handleViewportPointerDown);
    this.viewport.addEventListener('pointermove', this.handleViewportPointerMove);
    this.viewport.addEventListener('pointerup', this.handleViewportPointerUp);
    this.viewport.addEventListener('pointercancel', this.handleViewportPointerUp);
    if (this.mobileGallery) {
      this.mobileGallery.addEventListener('click', this.handleMobileGalleryClick);
    }
  }

  // Remove event listeners
  removeEventListeners() {
    for (let index = 0; index < this.openButtons.length; index += 1) {
      this.openButtons[index].removeEventListener('click', this.handleOpenButtonClick);
    }

    for (let index = 0; index < this.thumbnailButtons.length; index += 1) {
      this.thumbnailButtons[index].removeEventListener('click', this.handleThumbnailClick);
    }

    for (let index = 0; index < this.imageElements.length; index += 1) {
      const image = this.imageElements[index];
      image.removeEventListener('click', this.handleImageClick);
      image.removeEventListener('pointerdown', this.handleImagePointerDown);
      image.removeEventListener('pointermove', this.handleImagePointerMove);
      image.removeEventListener('pointerup', this.handleImagePointerUp);
      image.removeEventListener('pointercancel', this.handleImagePointerUp);
      image.removeEventListener('load', this.handleImageLoad);
      image.removeEventListener('error', this.handleImageError);
    }

    this.closeButton.removeEventListener('click', this.handleCloseButtonClick);
    this.zoomButton.removeEventListener('click', this.handleZoomButtonClick);
    this.previousButton.removeEventListener('click', this.handlePreviousButtonClick);
    this.nextButton.removeEventListener('click', this.handleNextButtonClick);
    this.dialog.removeEventListener('click', this.handleDialogClick);
    this.dialog.removeEventListener('close', this.handleDialogClose);
    this.desktopMediaQuery.removeEventListener('change', this.handleBreakpointChange);
    window.removeEventListener('resize', this.handleWindowResize);
    this.viewport.removeEventListener('scroll', this.handleViewportScroll);
    this.viewport.removeEventListener('pointerdown', this.handleViewportPointerDown);
    this.viewport.removeEventListener('pointermove', this.handleViewportPointerMove);
    this.viewport.removeEventListener('pointerup', this.handleViewportPointerUp);
    this.viewport.removeEventListener('pointercancel', this.handleViewportPointerUp);
    if (this.mobileGallery) {
      this.mobileGallery.removeEventListener('click', this.handleMobileGalleryClick);
    }
  }

  // Watch Flickity for mobile slide changes
  observeMobileGallery() {
    if (!this.mobileGallery || !this.mobileOpenButton) return;
    this.mobileGalleryObserver = new MutationObserver(this.handleMobileGalleryChange);
    this.mobileGalleryObserver.observe(this.mobileGallery, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
    this.updateMobileOpenButton();
  }

  // Update the mobile button when Flickity selects a slide
  handleMobileGalleryChange(mutations) {
    for (let index = 0; index < mutations.length; index += 1) {
      const changedElement = mutations[index].target;
      if (!changedElement.classList.contains('Carousel__Cell')) continue;
      this.updateMobileOpenButton();
      return;
    }
  }

  // Match the mobile button to the selected image slide
  updateMobileOpenButton() {
    const selectedSlide = this.mobileGallery.querySelector('.Carousel__Cell.is-selected');
    if (!selectedSlide) return;
    const imageIndex = selectedSlide.dataset.productZoomImageIndex;
    if (imageIndex === undefined) {
      this.mobileOpenButton.hidden = true;
      return;
    }

    this.mobileOpenButton.hidden = false;
    this.mobileOpenButton.dataset.imageIndex = imageIndex;
    this.mobileOpenButton.setAttribute(
      'aria-label',
      'Open image ' + (Number(imageIndex) + 1) + ' of ' + this.imageItems.length
    );
  }

  // Open the active image when its mobile gallery image is tapped
  handleMobileGalleryClick(event) {
    if (this.desktopMediaQuery.matches) return;
    if (!event.target.closest('img')) return;

    const imageSlide = event.target.closest('[data-product-zoom-image-index]');
    if (!imageSlide || !imageSlide.classList.contains('is-selected')) return;

    const requestedIndex = Number(imageSlide.dataset.productZoomImageIndex);
    this.lastOpenButton = this.mobileOpenButton;
    this.open(requestedIndex);
  }

  // Prioritise the active modal image
  prioritiseImage(imageIndex) {
    const imageItem = this.imageItems[imageIndex];
    if (!imageItem) return;
    const image = imageItem.querySelector('.product-zoom-modal__image');
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = 'high';
  }

  // Mark images as loaded
  handleImageLoad(event) {
    this.setImageLoaded(event.currentTarget);
  }

  // handle images that fail to load
  handleImageError(event) {
    this.setImageError(event.currentTarget);
  }

  // Show loaded images
  setImageLoaded(image) {
    const imageContainer = image.closest('[data-product-zoom-item], [data-product-zoom-thumbnail]');
    image.classList.add('is-loaded');
    if (!imageContainer) return;
    imageContainer.classList.add('is-loaded');
    imageContainer.classList.remove('has-error');
  }

  // if an image fails to load, allow it to show the alt text
  setImageError(image) {
    const imageContainer = image.closest('[data-product-zoom-item], [data-product-zoom-thumbnail]');
    if (!imageContainer) return;
    imageContainer.classList.add('has-error');
  }

  // Opens the modal at the clicked image
  handleOpenButtonClick(event) {
    const openButton = event.currentTarget;
    const requestedIndex = Number(openButton.dataset.imageIndex);
    this.lastOpenButton = openButton;
    this.open(requestedIndex);
  }

  // Close the modal when the close button is clicked
  handleCloseButtonClick() {
    this.close();
  }

  // Closes the modal when the dialog backdrop is clicked
  handleDialogClick(event) {
    if (event.target === this.dialog) {
      this.close();
    }
  }

  // Resets the modal after closing
  handleDialogClose() {
    this.resetZoom();
    document.documentElement.classList.remove('product-zoom-modal-is-open');
    if (this.lastOpenButton !== null) {
      this.lastOpenButton.focus();
    }
  }

  // Shows the previous mobile image and resets the zoom
  handlePreviousButtonClick() {
    this.resetZoom();
    const previousIndex = this.currentImageIndex - 1;
    this.setActiveImage(previousIndex, true);
  }

  // Shows the next mobile image and resets the zoom
  handleNextButtonClick() {
    this.resetZoom();
    const nextIndex = this.currentImageIndex + 1;
    this.setActiveImage(nextIndex, true);
  }

  // Scrolls to image clicked on for desktop thumbnails
  handleThumbnailClick(event) {
    const thumbnailButton = event.currentTarget;
    const requestedIndex = Number(thumbnailButton.dataset.imageIndex);
    this.resetZoom();
    this.setActiveImage(requestedIndex, false);
    this.keepActiveThumbnailVisible();
    this.scrollToCurrentImage(true, true);
  }

  // Toggles zoom for current mobile image
  handleZoomButtonClick() {
    if (this.isZoomed) {
      this.resetZoom();
      return;
    }
    const currentItem = this.imageItems[this.currentImageIndex];
    if (!currentItem) return;
    const currentImage = currentItem.querySelector('.product-zoom-modal__image');
    if (!currentImage) return;
    this.startZoom(currentItem, currentImage);
  }

  // Toggle zoom when the active modal image is clicked or tapped
  handleImageClick(event) {
    if (this.didDrag || this.didSwipe) {
      this.didDrag = false;
      this.didSwipe = false;
      return;
    }

    const clickedImage = event.currentTarget;
    const clickedItem = clickedImage.closest('[data-product-zoom-item]');
    if (!clickedItem) return;

    if (this.isZoomed && clickedItem === this.activeZoomItem) {
      this.resetZoom();
      if (this.desktopMediaQuery.matches) {
        window.requestAnimationFrame(() => {
          this.scrollToCurrentImage();
        });
      }
      return;
    }

    const clickedIndex = Number(clickedItem.dataset.imageIndex);
    this.resetZoom();
    this.setActiveImage(clickedIndex, false);
    this.startZoom(clickedItem, clickedImage);
  }

  // Dragging active image while zoomed
  handleImagePointerDown(event) {
    if (!this.isZoomed) return;
    if (event.currentTarget !== this.activeZoomImage) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    event.preventDefault();

    this.activePointerId = event.pointerId;
    this.isDragging = true;
    this.didDrag = false;
    this.dragStartX = event.clientX;
    this.dragStartY = event.clientY;
    this.dragStartPanX = this.panX;
    this.dragStartPanY = this.panY;
    this.activeZoomImage.classList.add('is-dragging');
    this.activeZoomImage.setPointerCapture(event.pointerId);
  }

  // Moves the zoomed image while dragging
  handleImagePointerMove(event) {
    if (!this.isDragging) return;
    if (event.pointerId !== this.activePointerId) return;
    event.preventDefault();

    const movementX = event.clientX - this.dragStartX;
    const movementY = event.clientY - this.dragStartY;
    if (Math.abs(movementX) > 3 || Math.abs(movementY) > 3) {
      this.didDrag = true;
    }

    const requestedPanX = this.dragStartPanX + movementX;
    const requestedPanY = this.dragStartPanY + movementY;
    this.setPan(requestedPanX, requestedPanY);
  }

  // Stops dragging the zoomed image
  handleImagePointerUp(event) {
    if (!this.isDragging) return;
    if (event.pointerId !== this.activePointerId) return;
    this.isDragging = false;
    this.activePointerId = null;

    if (this.activeZoomImage !== null) {
      this.activeZoomImage.classList.remove('is-dragging');
      if (this.activeZoomImage.hasPointerCapture(event.pointerId)) {
        this.activeZoomImage.releasePointerCapture(event.pointerId);
      }
    }

    if (this.didDrag) {
      window.setTimeout(() => {
        this.didDrag = false;
      }, 0);
    }
  }

  // Track horizontal mobile swipes while the image is zoomed out
  handleViewportPointerDown(event) {
    if (this.desktopMediaQuery.matches || this.isZoomed) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    this.swipePointerId = event.pointerId;
    this.swipeStartX = event.clientX;
    this.swipeStartY = event.clientY;
    this.swipeCurrentX = event.clientX;
    this.swipeCurrentY = event.clientY;
    this.didSwipe = false;
  }

  handleViewportPointerMove(event) {
    if (event.pointerId !== this.swipePointerId || this.isZoomed) return;
    this.swipeCurrentX = event.clientX;
    this.swipeCurrentY = event.clientY;
  }

  handleViewportPointerUp(event) {
    if (event.pointerId !== this.swipePointerId) return;

    const horizontalDistance = this.swipeCurrentX - this.swipeStartX;
    const verticalDistance = this.swipeCurrentY - this.swipeStartY;
    this.swipePointerId = null;

    if (event.type === 'pointercancel') return;
    if (this.isZoomed || Math.abs(horizontalDistance) < 50) return;
    if (Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;

    this.didSwipe = true;
    if (horizontalDistance < 0) {
      this.handleNextButtonClick();
    } else {
      this.handlePreviousButtonClick();
    }

    window.setTimeout(() => {
      this.didSwipe = false;
    }, 0);
  }

  // Tracks desktop gallery scroll
  handleViewportScroll() {
    if (!this.desktopMediaQuery.matches) return;
    if (this.isZoomed) return;
    if (this.scrollFrameRequested) return;

    this.scrollFrameRequested = true;
    window.requestAnimationFrame(() => {
      this.updateCurrentImageFromScroll();
      this.scrollFrameRequested = false;
    });
  }

  // Updates the active image and thumbnail using scroll position
  updateCurrentImageFromScroll() {
    const viewportRect = this.viewport.getBoundingClientRect();
    const visibilityThreshold = 0.75;
    let mostVisibleImageIndex = this.currentImageIndex;
    let highestVisibility = 0;

    for (let index = 0; index < this.imageItems.length; index += 1) {
      const imageItem = this.imageItems[index];
      const imageRect = imageItem.getBoundingClientRect();
      const visibleTop = Math.max(imageRect.top, viewportRect.top);
      const visibleBottom = Math.min(imageRect.bottom, viewportRect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const maximumVisibleHeight = Math.min(imageRect.height, viewportRect.height);
      const visiblePercentage = visibleHeight / maximumVisibleHeight;

      if (visiblePercentage > highestVisibility) {
        highestVisibility = visiblePercentage;
        mostVisibleImageIndex = index;
      }
    }

    if (highestVisibility < visibilityThreshold) return;
    if (mostVisibleImageIndex === this.currentImageIndex) return;
    this.setActiveImage(mostVisibleImageIndex, false);
    this.keepActiveThumbnailVisible();
  }

  // Keep the active thumbnail visible in the thumbnail list
  keepActiveThumbnailVisible() {
    const activeThumbnail = this.thumbnailButtons[this.currentImageIndex];
    if (!activeThumbnail) return;
    activeThumbnail.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  }

  // Reset the modal when resizing between mobile and desktop
  handleBreakpointChange() {
    if (!this.dialog.open) return;

    this.resetZoom();
    this.setActiveImage(this.currentImageIndex, true);
    if (this.desktopMediaQuery.matches) {
      window.requestAnimationFrame(() => {
        this.scrollToCurrentImage();
      });
    }
  }

  // Work out the pan position when the window size changes
  handleWindowResize() {
    if (!this.isZoomed) return;
    this.setPan(this.panX, this.panY);
  }

  // Opens the modal at the clicked image
  open(requestedIndex) {
    this.resetZoom();
    const shouldResetViewport = !this.desktopMediaQuery.matches;
    this.setActiveImage(requestedIndex, shouldResetViewport);
    if (!this.dialog.open) {
      this.dialog.showModal();
    }

    document.documentElement.classList.add('product-zoom-modal-is-open');

    if (this.desktopMediaQuery.matches) {
      window.requestAnimationFrame(() => {
        this.scrollToCurrentImage();
      });
    }
  }

  // Close the modal
  close() {
    if (!this.dialog.open) return;
    this.dialog.close();
  }

  // Set the current image and update controls
  setActiveImage(requestedIndex, resetViewportPosition) {
    if (Number.isNaN(requestedIndex)) {
      requestedIndex = 0;
    }
    if (requestedIndex < 0) {
      requestedIndex = 0;
    }

    const lastImageIndex = this.imageItems.length - 1;
    if (requestedIndex > lastImageIndex) {
      requestedIndex = lastImageIndex;
    }
    this.currentImageIndex = requestedIndex;
    this.prioritiseImage(this.currentImageIndex);

    for (let index = 0; index < this.imageItems.length; index += 1) {
      const imageItem = this.imageItems[index];
      const isActive = index === this.currentImageIndex;
      if (isActive) {
        imageItem.classList.add('is-active');
      } else {
        imageItem.classList.remove('is-active');
      }
    }

    for (let index = 0; index < this.thumbnailButtons.length; index += 1) {
      const thumbnailButton = this.thumbnailButtons[index];
      const isActive = index === this.currentImageIndex;
      if (isActive) {
        thumbnailButton.classList.add('is-active');
        thumbnailButton.setAttribute('aria-current', 'true');
      } else {
        thumbnailButton.classList.remove('is-active');
        thumbnailButton.removeAttribute('aria-current');
      }
    }

    if (resetViewportPosition) {
      this.viewport.scrollTop = 0;
      this.viewport.scrollLeft = 0;
    }
    this.updateMobileNavigation();
  }

  // Update the mobile image counter and arrows
  updateMobileNavigation() {
    const currentNumber = this.currentImageIndex + 1;
    const totalImages = this.imageItems.length;
    this.counter.textContent = currentNumber + ' / ' + totalImages;
    this.previousButton.disabled = this.currentImageIndex === 0;
    this.nextButton.disabled = this.currentImageIndex === totalImages - 1;
  }

  // Zoom image and reset pan position
  startZoom(imageItem, image) {
    this.zoomScale = this.desktopMediaQuery.matches ? 1.5 : 2.5;
    this.activeZoomItem = imageItem;
    this.activeZoomImage = image;
    this.isZoomed = true;
    this.panX = 0;
    this.panY = 0;
    this.classList.add('is-zoomed');
    this.activeZoomImage.classList.add('is-zoomed');
    this.updateZoomButton();
    this.updateImageTransform();
    window.requestAnimationFrame(() => {
      this.setPan(0, 0);
    });
  }

  // Reset image to normal size and clear drag state
  resetZoom() {
    if (this.activeZoomImage !== null) {
      this.activeZoomImage.classList.remove('is-zoomed', 'is-dragging');
      this.activeZoomImage.style.transform = '';
    }
    this.classList.remove('is-zoomed');
    this.isZoomed = false;
    this.isDragging = false;
    this.activePointerId = null;
    this.activeZoomItem = null;
    this.activeZoomImage = null;
    this.panX = 0;
    this.panY = 0;
    this.updateZoomButton();
  }

  // Keep pan position within image bounds
  setPan(requestedPanX, requestedPanY) {
    if (!this.isZoomed) return;
    const panBounds = this.getPanBounds();
    this.panX = Math.max(-panBounds.maximumX, Math.min(panBounds.maximumX, requestedPanX));
    this.panY = Math.max(-panBounds.maximumY, Math.min(panBounds.maximumY, requestedPanY));
    this.updateImageTransform();
  }

  // Work out image bounds
  getPanBounds() {
    const viewportWidth = this.viewport.clientWidth;
    const viewportHeight = this.viewport.clientHeight;
    const imageWidth = this.activeZoomImage.offsetWidth;
    const imageHeight = this.activeZoomImage.offsetHeight;
    const zoomedWidth = imageWidth * this.zoomScale;
    const zoomedHeight = imageHeight * this.zoomScale;
    const maximumX = Math.max(0, (zoomedWidth - viewportWidth) / 2);
    const maximumY = Math.max(0, (zoomedHeight - viewportHeight) / 2);
    return {
      maximumX: maximumX,
      maximumY: maximumY
    };
  }

  // Apply zoom and pan values to active image
  updateImageTransform() {
    if (this.activeZoomImage === null) return;
    this.activeZoomImage.style.transform = 'translate3d(' + this.panX + 'px, ' + this.panY + 'px, 0) scale(' + this.zoomScale + ')';
  }

  // Update the mobile zoom button and label
  updateZoomButton() {
    if (!this.zoomButton) return;

    if (this.isZoomed) {
      this.zoomButton.setAttribute('aria-label', 'Zoom out');
      this.zoomPlusIcon.setAttribute('hidden', '');
      this.zoomMinusIcon.removeAttribute('hidden');
    } else {
      this.zoomButton.setAttribute('aria-label', 'Zoom in');
      this.zoomPlusIcon.removeAttribute('hidden');
      this.zoomMinusIcon.setAttribute('hidden', '');
    }
  }

  // Scroll the desktop gallery to the current image
  scrollToCurrentImage(smoothScroll = false, centreImage = false) {
    if (!this.desktopMediaQuery.matches) return;
    const currentImage = this.imageItems[this.currentImageIndex];
    if (!currentImage) return;
    let scrollTop = currentImage.offsetTop;
    let scrollBehaviour = 'auto';

    // Clicking thumbnails on desktop modal
    if (centreImage) {
      scrollTop = currentImage.offsetTop - ((this.viewport.clientHeight - currentImage.offsetHeight) / 2);
      const maximumScrollTop = this.viewport.scrollHeight - this.viewport.clientHeight;
      scrollTop = Math.max(0, Math.min(maximumScrollTop, scrollTop));
    }

    if (smoothScroll) {
      scrollBehaviour = 'smooth';
    }

    this.viewport.scrollTo({
      top: scrollTop,
      left: 0,
      behavior: scrollBehaviour
    });
  }
}

if (!customElements.get('product-zoom-modal')) {
  customElements.define('product-zoom-modal', ProductZoomModal);
}
